module.exports = __webpack_public_path__ + "assets/img/bug-icon.9ffae6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bug-icon.png
// module id = xR7u
// module chunks = 1